import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { DropdownFilter, FloatInput, FloatSelect } from "src/componentes";
import { ConsultarPessoa } from "src/hook/Consulta/ConsultaPessoa.Module";
import PessoaCadastroView from "src/pages/Privada/Entidade/Pessoa/Cadastro/PessoaCadastro.View";
import { PessoaDto } from "src/pages/Privada/Entidade/Pessoa/Pessoa.Dto";
import yup from "src/validators/yup.Module";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../NFe.Dto";

const NFeCadastroDestinatarioView = () => {
  const navigate = useNavigate();
  const [cadastro, setCadastro] = useState<boolean>(false);
  const pessoaBuscar = ConsultarPessoa();
  const nf = getLocal<NFeDto>(STORAGENFE_KEY);
  const destinatario = nf?.destinatario;
  const consumidorFinal = nf?.consumidorFinal;

  const PessoaFiltrarSchema = yup.object().shape({
    id: yup
      .number()
      .min(1, "Selecione uma pessoa")
      .required("Selecione uma pessoa"),
  });

  const form = useForm<PessoaDto>({
    resolver: yupResolver(PessoaFiltrarSchema),
    defaultValues: destinatario || {},
  });

  const id = form.getValues("id");

  const handleVoltar = () => () => {
    navigate("../tributacao");
  };

  const handleSuccess = (value: PessoaDto) => {
    form.reset(value);
    setCadastro(false);
  };

  const handleCancel = () => {
    setCadastro(false);
  };

  const onSubmit = async (data: PessoaDto, e: any) => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      destinatario: data,
    });
    if (consumidorFinal === undefined) {
      if (data.indicadorInscricaoEstadual === 9) {
        updateLocal<NFeDto>(STORAGENFE_KEY, {
          consumidorFinal: 1,
        });
      } else {
        updateLocal<NFeDto>(STORAGENFE_KEY, {
          consumidorFinal: 0,
        });
      }
    }
    navigate("../consumidorfinal");
  };

  if (cadastro) {
    return (
      <Row>
        <PessoaCadastroView
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          initialValue={form.getValues("id") > 0 ? form.getValues() : undefined}
        />
      </Row>
    );
  }

  return (
    <>
      <Form noValidate onSubmit={form.handleSubmit(onSubmit)}>
        <Row>
          <Col xs={12}>
            <DropdownFilter<PessoaDto>
              fetchData={pessoaBuscar.PessoaBuscar}
              loading={pessoaBuscar.loading}
              labelDescription="Destinatário"
              getDescription={(item: PessoaDto) => item.nome}
              getId={(item: PessoaDto) => item.id}
              registeredFields={{
                id: form.register("id"),
                description: form.register("nome"),
              }}
              errorsMessageDescription={form.formState.errors.id}
              onSelect={(item: PessoaDto | undefined) => {
                if (item !== undefined) {
                  form.reset(item);
                } else {
                  form.reset({});
                  form.setValue("id", 0);
                  form.setValue("nome", "");
                }
              }}
            ></DropdownFilter>
          </Col>

          {id > 0 ? (
            <Col>
              <Button variant="link" onClick={() => setCadastro(true)}>
                Alterar
              </Button>
            </Col>
          ) : (
            <Col>
              <Button variant="link" onClick={() => setCadastro(true)}>
                Novo
              </Button>
            </Col>
          )}
        </Row>
        {id > 0 && (
          <>
            <Row>
              <Col xs={12} md={4}>
                <FloatInput
                  label="Documento"
                  registerField={form.register("documento")}
                  readOnly={true}
                />
              </Col>
              <Col xs={9} md={6}>
                <FloatInput
                  label="Município"
                  registerField={form.register("nomeMunicipio")}
                  readOnly={true}
                />
              </Col>
              <Col xs={3} md={2}>
                <FloatInput
                  label="UF"
                  registerField={form.register("uf")}
                  readOnly={true}
                />
              </Col>
            </Row>
          </>
        )}
        <div className="fixed-bottom">
          <Container className="py-3">
            <Row>
              <Col xs={6} className="d-grid">
                <Button variant="outline-secondary" onClick={handleVoltar()}>
                  Voltar
                </Button>
              </Col>
              <Col xs={6} className="d-grid">
                <Button variant="outline-primary" type="submit">
                  Próximo
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Form>
    </>
  );
};
export default NFeCadastroDestinatarioView;
